import { IPageDataState, ISetPageDataProductListAction, ISetPageDataProductOverviewAction } from "./types";
import ActionTypes from '../../../constants/ActionTypes';

const initialState: IPageDataState = {
  productList: {},
  productOverview: {},
};
const pageDataReducer = (
  state = initialState,
  action: ISetPageDataProductListAction | ISetPageDataProductOverviewAction,
): IPageDataState => {
  switch (action.type) {
  case ActionTypes.PAGE_DATA_DEVICE_LIST.SET:
    return {
      ...state,
      productList: action.payload
    };
  case ActionTypes.PAGE_DATA_DEVICE_OVERVIEW.SET:
    return {
      ...state,
      productOverview: action.payload
    };
  }
  return state;
};

export default pageDataReducer;
